import React, { useState } from "react";
import { PickerView, Input, Button } from "zarm";
import Keyboard from "@wap/components/Keyboard";
import Tabulation from "@wap/components/Tabulation";
import * as utils from "../utils";
import "./index.less";
const dataList = [
  { value: 0, label: "<3.7 (<0.05)" },
  { value: 1, label: "3.7 (0.05)" },
  { value: 2, label: "3.8 (0.06)" },
  { value: 3, label: "3.9 (0.08)" },
  { value: 4, label: "4.0 (0.1)" },
  { value: 5, label: "4.1 (0.12)" },
  { value: 6, label: "4.2 (0.15)" },
  { value: 7, label: "4.3 (0.2)" },
  { value: 8, label: "4.4 (0.25)" },
  { value: 9, label: "4.5 (0.3)" },
  { value: 10, label: "4.6 (0.4)" },
  { value: 11, label: "4.7 (0.5)" },
  { value: 12, label: "4.8 (0.6)" },
  { value: 13, label: "4.9 (0.8)" },
  { value: 14, label: "5.0 (1.0)" },
  { value: 15, label: "5.1 (1.2)" },
  { value: 16, label: "5.2 (1.5)" },
  { value: 17, label: "5.3 (2.0)" },
];
const SubsideStatus = dataList.map((val) => val.label);
class EyeSightExamItem extends React.Component {
  constructor(props) {
    super(props);
    const { data = {} } = this.props;
    const { examContent } = data;
    const { dataOdNakedVision, dataOsNakedVision } = examContent;
    examContent.examODContent = dataOdNakedVision;
    examContent.examOSContent = dataOsNakedVision;
    this.state = {
      data: { ...data, examContent },
      eyeType: "OD",
      visible: false,
    };
    this.tabRef = React.createRef();
  }

  /*
   * 回调方法
   */
  handleResult = () => {
    const {data} = this.state;
    
    const { examContent, ...rest } = data;
    const { examODContent, examOSContent} = examContent;
    // const { examODContent, }
    const opticData = {
      dataOdNakedVision: examODContent,
      dataOsNakedVision: examOSContent,
    };
    const params = {
      ...rest,
      examContent: opticData,
    };
    return params;
  };

  /**
   * 类型切换
   * @param type 眼别类型
   */
  onKeyTypeChange = (type) => {
    // 检查项的配置
    // const { config = {} } = this.props;
    // // 检查项的指标的key
    // const { examIndiList = {} } = config; // 获取对应眼别的检查项的指标列表
    // // 找到对应的指标列表
    // const examKeyList = examIndiList[`${type.toLowerCase()}List`] || [];
    // let name = examKeyList[0]?.option?.key;
    // // 指标的list只有一个，且有account属性（即一个指标key，但是在页面上是多个输入框）
    // if (examKeyList.length === 1 && examKeyList[0]?.account) {
    //   name = `${examKeyList[0]?.option?.key}@1`;
    // }
    let name = `exam${type}Content`;

    this.tabRef.current.inputAutoFocusByName(name);

    this.setState({ eyeType: type });
  };
  /**
   * 键盘退格
   */
  onKeyBackspace = () => {
    this.tabRef.current.onBackspace();
  };
  /**
   * 下一页
   */
  onKeyNext = () => {
    this.tabRef.current.onNext();
  };
  onTabChange = (name, value, unavailableText) => {
    let eyeType = "";

    if (/OD/.test(name)) {
      eyeType = "OD";
    } else {
      eyeType = "OS";
    }
    eyeType !== this.state.eyeType && this.setState({ eyeType });
  };
  /**
   * inputKeyValueChange input的值返回，也可以在onInputChange方法中获取当前改变的值
   * @param value 键盘输入值改变
   */
  onKeyValueChange = (value) => {
    const inputValue = this.tabRef.current.inputKeyValueChange(value);
  };
  /**
   * 当前输入框的值改变时候
   */
  onInputChange = (name, value) => {
    const { data } = this.state;
    const { examContent = {} } = data;
    const test = { ...data, examContent: { ...examContent, [name]: value } };
    this.setState({
      data: test,
    });
  };
  /**
   * 输入框失去焦点
   */
  onInputBlur = (name, value, element) => {
    // const format = {
    //   fixed: 2,
    //   min: 1,
    //   // reg: "/^(\\-|\\+)?\\d{0,2}(.\\d{2})?$/",
    //   replacement: "#{value}",
    // };
    // // 判断是否需要格式化
    // if (format) {
    //   value = value && utils.format.done(format, value);
    // }
    // if(value.includes('<')){
    //   value = value;
    // } else {
    //   value = value && utils.format.done(format, value);
    // }
    // state控制的则调用此方法
    this.onInputChange(name, value);
  };
  handleCheckValue = (item) => {
    // const value = item.label.split(" (")[0];
    const value = item.label;
    const name = `exam${this.state.eyeType}Content`;
    this.tabRef.current.onTabInput(this.state.eyeType === 'OD' ? 0 : 1)
    this.onInputChange(name, value);
  };
  showKeyBord = () => {
    this.setState({ visible: !this.state.visible });
    this.tabRef.current.onTabInput(this.state.eyeType === 'OD' ? 0 : 1)
  };
  render() {
    const { eyeType = "OD", visible } = this.state;
    // 检查项的配置
    const { config = {} } = this.props;
    const { data } = this.state;
    // 检查项的指标的key
    const { examIndiList = {}, unavailableKeys = [] } = config;
    const { examContent = {} } = data;
    return (
      <div style={{ background: "#fff" }}>
        <div className="input-wrapper">
          <div>
            <Tabulation
              border // input输入框的的边框是否显示
              defaultMaxLength={1} // 整个组件默认的最大输入值，每个输入框可以通过 maxLength 自定义
              defaultUnavailableText="@/+-" // 整个组件默认的不可输入的字符
              onTabChange={this.onTabChange} // 焦点切换时回调 name, value, inputElement?
              onInputChange={this.onInputChange} // 输入时候回调 name, value, inputElement?
              onInputBlur={this.onInputBlur} // 输入框失去焦点后回调 name, value, inputElement?
              ref={this.tabRef}
            >
              {["od", "os"].map((type, index) => {
                // 获取对应眼别的检查项的指标列表
                const examKeyList = examIndiList[`${type}List`] || [];
                const typeArray = type.split('');
                const key = `exam${type.toLocaleUpperCase()}Content`;
                // const key = `data${typeArray[0].toLocaleUpperCase()}${typeArray[1]}NakedVision`
                // 每行的数量
                let rowAccout;
                // 总的数量
                let tabIndexList = [];

                return (
                  <div style={{ display: "flex", padding: "0 16px" }} key={key}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        minWidth: "28px",
                      }}
                    >
                      {type.toLocaleUpperCase()}:
                    </div>
                    <Tabulation.TabInput
                      tabIndex={index}
                      name={key}
                      value={examContent[key]}
                      maxLength={15}
                      placeholder="请输入"
                      width={200}
                      className="large_input"
                    />
                  </div>
                );
              })}
            </Tabulation>
          </div>
          <Button size="sm" theme="primary" ghost onClick={this.showKeyBord}>键盘输入</Button>
        </div>

        <div className="button-wrapper">
          {dataList.map((item) => {
            return (
              <Button
                className="eyebutton"
                theme="primary"
                size="sm"
                key={item.value}
                onClick={() => this.handleCheckValue(item)}
              >
                {item.label}
              </Button>
            );
          })}
        </div>
        {/* <div className="">
          {
            ['OD', 'OS'].map((type, index) => {
              return (
                <Input
                  ref={r => this[`${type}InputFocus`] = r}
                  key={type}
                  type="price"
                  placeholder="请输入"
                />
              )
            })
          }
          {dataList.map((item) => {
            return <Button theme="primary" key={item.value} onClick={() => this.handleCheckValue(item)}>{item.label}</Button>
          })}
        
        </div> */}
        {visible && (
          <div className="keybord-Wrapper">
            <Keyboard
              // visible={false}
              unavailableKeys={unavailableKeys}
              eyeType={eyeType}
              onKeyNext={this.onKeyNext}
              onKeyBackspace={this.onKeyBackspace}
              onKeyTypeChange={this.onKeyTypeChange}
              onKeyValueChange={this.onKeyValueChange}
            />
          </div>
        )}
      </div>
    );
  }
}

export default EyeSightExamItem;
